<template>
  <el-container class="list" style="display:block;">

		<el-row class="s-list lel">
			<el-col :span="8">
				<div class="block">
				<span class="demonstration">日期选择:</span>
				<el-date-picker
				  v-model="times"
				  type="daterange"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期"
				  format="yyyy 年 MM 月 dd 日"
				  value-format="yyyy-MM-dd">
				</el-date-picker>

			  </div>
			</el-col>
			<el-col :span="1" class="t-searched" @click.native="search()">筛选</el-col>
			<el-col :span="1" class="t-searched" @click.native="month()">当月</el-col>
		</el-row>

			 <template>
			  <el-table
				:data="tableData"
				border
				style="width: 100%;margin-left: 0;">
				<el-table-column
				  prop="date"
				  label="日期"
				   >
				</el-table-column>
				<el-table-column
				  prop="user_name"
				  label="姓名"
				   >
				</el-table-column>
				<el-table-column
				  prop="items"
				  label="录入数量"
				   >
				</el-table-column>
				<el-table-column
				  prop="test"
				  label="测试数量"
				   >
				</el-table-column>

			  </el-table>
			</template>

       
  </el-container>
</template>

<script>

  export default {
    data() {
      return {

      value2:'',
        tableData:[],

		times:'',
		type:2,
		 url:this.$store.getters.getUrl
      };
    },
    created() {
      // if(!window.localStorage.getItem('id')){
      //   this.$router.push({ path: '/' })
      // }
	//var cip = returnCitySN["cip"];
// 	if(this.$store.getters.getRole != 'admins'){
// 			   if(cip !='117.9.19.251' && cip !='60.27.105.250' && cip !='60.27.106.235'){
// 				   this.$router.push({ path: '/' })
// 			   }
// 	}
       this.loadData()
    },
	methods:{

		loadData(){

			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
      console.log(this.value2)
			let times = '';
			if(this.times != ''&&this.times != null){
				times = this.times[0]+','+this.times[1];
			}
			axiosInstance({
				method:'post',
				url:'http://fencip.yoooooo.com/index.php/index/data/staff',
				params:{
					times:times,
					type:this.type
				}
			})
			.then(res=>{
				this.tableData = res.data.data

			})
			.catch(err=>{

			});
		},
		month(){
			this.type = 2;
			this.loadData();
		},
		search(){
			this.type = 1;
			if(this.times != ''&&this.times != null){
				this.loadData();
			}else{
				this.msg('请选择时间','error')
			}

		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},

		}


  }
</script>

<style>


	.list{
		margin-left: 15%;
		margin-right: 15%;
	}
	.h-list{
		margin: 30px 30px 30px 20px;
		background: #fff;
		height: 50px;
	}
	.h-list .el-col{
		line-height: 50px;

	}

	.s-list{
		margin-bottom: 30px;
		margin-top: 30px;

	}
	.t-searched{
		background: orange;
		color: #fff;
		height: 35px;
		line-height: 35px;
		margin-left: 10px;
		text-align: center;
	}

</style>



// WEBPACK FOOTER //
// src/components/main/tj.vue